function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBemerkungIntern = function SvgBemerkungIntern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.2 0H1.8A1.805 1.805 0 0 0 0 1.8V18l3.6-3.6h12.6a1.805 1.805 0 0 0 1.8-1.8V1.8A1.805 1.805 0 0 0 16.2 0Zm-1.8 10.8H3.6V9h10.8Zm0-2.7H3.6V6.3h10.8Zm0-2.7H3.6V3.6h10.8Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgBemerkungIntern;